module.exports = __webpack_public_path__ + "img/logo.e9e0e8cd.svg";